import {
  AvailabilityRequestEnum,
  AvailabilityRequest,
  AvailabilityResponse,
  PlatformEnum,
  LodgingSelectionEnum,
  IdEnum,
  IIdLodgings,
} from "redmond";
import { actions as searchActions } from "../../search/actions";

import { isMobile } from "../../../utils/userAgent";
import { actions } from "../actions";
import Logger from "../../../utils/logger";
import { put, putResolve } from "redux-saga/effects";
import dayjs from "dayjs";
import { PATH_HOME } from "../../../utils/paths";
import { fetchStaysAvailability } from "../../../api/v0/availability/fetchStaysAvailability";

export function* fetchWishlistAvailabilitySaga(
  action: actions.IFetchWishlistAvailability
) {
  const { lodgingIds, stayDates, guests, numRooms } = action;

  if (lodgingIds.length === 0) {
    action.history.push(PATH_HOME);
  }

  const fromDate = dayjs(stayDates.fromDate);
  const untilDate = dayjs(stayDates.untilDate);
  const petsCount = guests.petsIncluded ? 1 : 0;
  const adultsCount = guests.numAdults;
  const childrenAges = guests.childrenAges;

  try {
    let requestBody: AvailabilityRequest = {
      lodgingSelection: {
        LodgingSelection: LodgingSelectionEnum.LodgingIds,
        lodgingIds: lodgingIds,
      },
      stayDates: {
        from: fromDate.format("YYYY-MM-DD"),
        until: untilDate.format("YYYY-MM-DD"),
      },
      guests: {
        adults: adultsCount,
        children: childrenAges,
        pets: petsCount,
      },
      platform: isMobile() ? PlatformEnum.Mobile : PlatformEnum.Desktop,
      progressiveConfig: {},
      ...(numRooms > 1 && { rooms: { numberOfRooms: numRooms } }),
      AvailabilityRequest: AvailabilityRequestEnum.InitialSearch,
    };

    let availabilityResponse: AvailabilityResponse =
      yield fetchStaysAvailability(requestBody);

    yield putResolve(searchActions.setFromDate(fromDate.toDate()));
    yield putResolve(searchActions.setUntilDate(untilDate.toDate()));
    yield putResolve(searchActions.setPetsCount(petsCount));
    yield putResolve(
      searchActions.setOccupancyCounts({
        adults: adultsCount,
        children: childrenAges,
      })
    );
    yield putResolve(searchActions.setRoomsCount(numRooms));

    // Needed to validate if search is dirty
    yield put(actions.setSearchedDates(fromDate.toDate(), untilDate.toDate()));
    yield put(actions.setSearchedPetsCount(petsCount));
    yield put(
      actions.setSearchedOccupancyCounts({
        adults: adultsCount,
        children: childrenAges,
      })
    );
    yield put(actions.setSearchedRoomsCount(numRooms));

    const location = {
      id: {
        Id: IdEnum.Lodgings,
        lodgingSelection: {
          LodgingSelection: LodgingSelectionEnum.LodgingIds,
          lodgingIds: lodgingIds,
        },
      } as IIdLodgings,
      label: "",
    };
    yield putResolve(searchActions.setLocation(location));
    yield put(actions.setSearchedLocationResult(location));

    yield put(
      actions.setWishlistAvailabilityResults({
        payload: availabilityResponse,
      })
    );
  } catch (e) {
    yield put(actions.setHotelAvailabilityCallStateFailed());
    Logger.debug(e);
  }
}
